import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const EgitimlerPage = lazy(() => import('../pages/egitimler/page'));
const UrunlerPage = lazy(() => import('../pages/urunler/page'));
const UrunDetayPage = lazy(() => import('../pages/urunler/detail/page'));
const RandevuPage = lazy(() => import('../pages/randevu/page'));
const SohbetPage = lazy(() => import('../pages/sohbet/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const BasindaBizPage = lazy(() => import('../pages/basinda-biz/page'));
const SSSPage = lazy(() => import('../pages/sss/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service detail pages
const AstrolojikDanismanlikPage = lazy(() => import('../pages/services/astrolojik-danismanlik/page'));
const SpirituelDanismanlikPage = lazy(() => import('../pages/services/spirituel-danismanlik/page'));
const SifaEnerjiPage = lazy(() => import('../pages/services/sifa-enerji/page'));

// Legal pages
const GizlilikPage = lazy(() => import('../pages/gizlilik/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const MesafeliSatisPage = lazy(() => import('../pages/mesafeli-satis/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetler/astrolojik-danismanlik',
    element: <AstrolojikDanismanlikPage />,
  },
  {
    path: '/hizmetler/spirituel-danismanlik',
    element: <SpirituelDanismanlikPage />,
  },
  {
    path: '/hizmetler/sifa-enerji',
    element: <SifaEnerjiPage />,
  },
  {
    path: '/egitimler',
    element: <EgitimlerPage />,
  },
  {
    path: '/urunler',
    element: <UrunlerPage />,
  },
  {
    path: '/urunler/:id',
    element: <UrunDetayPage />,
  },
  {
    path: '/randevu',
    element: <RandevuPage />,
  },
  {
    path: '/sohbet',
    element: <SohbetPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:id',
    element: <BlogDetailPage />,
  },
  {
    path: '/basinda-biz',
    element: <BasindaBizPage />,
  },
  {
    path: '/sss',
    element: <SSSPage />,
  },
  {
    path: '/iletisim',
    element: <IletisimPage />,
  },
  {
    path: '/gizlilik',
    element: <GizlilikPage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/mesafeli-satis',
    element: <MesafeliSatisPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;